import { Chip, ChipProps } from '@mui/material';

type JobStatus = 'pending' | 'processing' | 'completed' | 'failed' | 'cancelled';

interface StatusBadgeProps {
  status: JobStatus;
  size?: ChipProps['size'];
}

const statusConfig: Record<JobStatus, { label: string; color: ChipProps['color'] }> = {
  pending: { label: 'Pendiente', color: 'default' },
  processing: { label: 'Procesando', color: 'info' },
  completed: { label: 'Completado', color: 'success' },
  failed: { label: 'Fallido', color: 'error' },
  cancelled: { label: 'Cancelado', color: 'warning' },
};

export default function StatusBadge({ status, size = 'small' }: StatusBadgeProps) {
  const config = statusConfig[status] || statusConfig.pending;

  return (
    <Chip
      label={config.label}
      color={config.color}
      size={size}
      sx={{ fontWeight: 600 }}
    />
  );
}
